import React from 'react'

import { FadeIn, Spinner, Label, OrderListItem } from '@pb/components'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { ACCOUNT_ROUTES } from 'App/constants'
import SecondaryAction from 'ui/buttons/SecondaryAction'

import { operationFetchStoreOrders } from '../../duck/operations'
import { getStoreStreetName } from '../../helpers/purchases'
import styles from './StoreOrdersList.scss'

const StoreOrdersList: React.FC<any> = ({
  isOrdersLoading,
  orders,
  isStoreOrderAddressesFailed,
  shouldShowLoadMoreButton,
}) => {
  const dispatch = useDispatch()

  const handleLoadMore = (): any => {
    dispatch(operationFetchStoreOrders())
  }

  return (
    <div className={styles.container}>
      <ul>
        {orders.map(({ totalAmount, date, statusDisplay, isCancelled, storeInfo, orderId }) => (
          <OrderListItem
            Tag="li"
            key={orderId}
            orderMetaData={!isStoreOrderAddressesFailed ? getStoreStreetName(storeInfo) : null}
            orderDate={date}
            orderAmount={totalAmount}
            orderStatusDisplay={statusDisplay}
            isOrderCancelled={isCancelled}
            orderDetailRoute={`${ACCOUNT_ROUTES.StoreOrderDetails.path}/${orderId}`}
          />
        ))}
      </ul>
      {shouldShowLoadMoreButton && (
        <FadeIn className={styles.loadMoreButtonContainer}>
          <SecondaryAction
            size="large"
            onClick={handleLoadMore}
            className={styles.loadMoreButton}
            fullWidth
          >
            <Spinner isRendered={isOrdersLoading} containerClassName={styles.spinner} />
            <Label copyKey="account.digitalreceipts.loadmore" />
          </SecondaryAction>
        </FadeIn>
      )}
    </div>
  )
}

StoreOrdersList.propTypes = {
  isOrdersLoading: PropTypes.bool.isRequired,
  orders: PropTypes.any.isRequired,
  isStoreOrderAddressesFailed: PropTypes.bool,
}

export default StoreOrdersList
